import * as React from 'react';
import { SVGS } from '../../../assets/images';
import { Box } from '@mui/material';
import styles from './search-input.module.scss';

interface Props {
    searchValue: string;
    placeholder?: string;
    onChange: (searchString: string) => void;
    width?: string;
    minWidth?: string;
    disabled?: boolean;
}

export default function SearchInput(props: Props) {
    return (
        <Box
            className={styles.container}
            style={{
                width: props.width,
                minWidth: props.minWidth
            }}>
            <SVGS.SearchIcon className={styles.icon} />
            <div className={styles.inputContainer}>
                <input
                    id='searchInput'
                    className={styles.input}
                    size={30}
                    value={props.searchValue}
                    placeholder={props.placeholder ? props.placeholder : 'Search'}
                    onChange={(event) => props.onChange(event.target.value)}
                    disabled={props.disabled}
                />
            </div>
        </Box>
    );
}
